import { Pipe, PipeTransform } from '@angular/core';
// 10-year-range build instead of the full `moment-timezone`: the complete zone dataset is
// ~700 kB and this pipe is declared in SharedModule, so it lands in the initial bundle.
import moment from 'moment-timezone/builds/moment-timezone-with-data-10-year-range';

@Pipe({
    name: 'timezoneDate',
    standalone: false
})
export class TimezoneDatePipe implements PipeTransform {
  transform(
    value: Date | string | number | null | undefined,
    format: string = 'DD/MM/YYYY HH:mm',
    timezone: string = 'America/Sao_Paulo'
  ): string {
    if (!value) {
      return '';
    }

    return moment(value).tz(timezone).format(format);
  }
}